var parts = ['container'];
var baseStyle = {
  container: {
    mb: 5
  }
};
var Form = {
  parts: parts,
  baseStyle: baseStyle
};
export { Form as default };